<script>
import ShopBox from "@/components/home/box/ShopBox.vue";
import {api} from "@/modules/api";

export default {
  name: 'ShopBlock',
  components: {ShopBox},
  data () {
    return {
      products: {}
    }
  },
  mounted () {
    this.loadData()
  },
  methods: {
    loadData () {
      api.categories.getByName('produits-derives').then(res => {
        this.products = res
      })
    }
  }
}
</script>

<template>
<div class="mt-10 min-h-screen w-full">
  <div class="w-full flex flex-col">
    <h1 class="text-center uppercase font-extrabold text-primary-700 text-3xl lg:text-7xl mb-20 font-sigmar tracking-wider">Marchandises</h1>
  </div>
  <div class="flex flex-wrap px-5 lg:px-20">
    <shop-box v-for="(product, index) in products" :key="index" :label="product.title" :price="product.price" :image="product.Images[0].url" :tag="product.tag"  />
  </div>
</div>
</template>
